import { Getters } from '@/shared/app/model/store/getters';
import Template from '@/shared/app/model/templating/Template';
import Dataset from '@/shared/data/model/Dataset';
import { DishesGroupConfig } from '../components/dishesGroup/ui/types';

export interface MakeUniAccueilStandOptions {
  datasetName: string;
  originsIcons: Dataset;
  headerImageMode?: 'side' | 'top';
  headerImage?: string;
  headerImageBasis?: string;
  headerImageBackgroundSize?: string;
  sizeFactor?: number;
  waitingtime?: boolean;
  borderRadius?: string;
  borderWidth?: string;
  backgroundColorValue?: string;
  padding?: string;
  dishGroupConfig?: DishesGroupConfig;
  dishConfig?: Dataset;
  sides?: boolean;
  getters?: Getters;
}

export const makeUniAccueilStand = (opts: MakeUniAccueilStandOptions): Template => {
  const padding = opts.padding || '1rem';
  const borderRadius = opts.borderRadius || '0.6rem';
  const borderWidth = opts.borderWidth || '0';
  const sizeFactor = opts.sizeFactor || 1;

  let sides = '';
  if (opts.sides === true && opts.getters)
    sides = opts.getters.value(opts.datasetName, 'sides')?.toString() || '';

  let waitingtime = '';
  if (opts.waitingtime === true && opts.getters)
    waitingtime = opts.getters.value(opts.datasetName, 'waiting_time')?.toString() || '';

  return {
    component: 'Box',
    config: {
      background: true,
      backgroundColorValue: opts.backgroundColorValue || 'white',
      border: true,
      borderRadius,
      borderWidth,
      padding,
    },
    slots: {
      ext: {
        component: 'AutoFlex',
        config: {
          grow: '0',
          basis: '0',
          headerBasis: opts.headerImageBasis || '20%',
          offreGrow: '1',
          spaceBetween: padding,
        },
        slots: {
          header: {
            component: 'Box',
            config: {
              background: true,
              backgroundImage: true,
              backgroundColor: 'red',
              backgroundSize: opts.headerImageBackgroundSize || 'cover',
              borderRadius,
              ...(opts.headerImage ? { backgroundImagePath: opts.headerImage } : {}),
            },
          },
          offre: {
            component: 'AutoFlex',
            config: {
              vertical: true,
              dishesGrow: '1',
              sidesGrow: '0',
              waitingtimeGrow: '0',
            },
            slots: {
              dishes: {
                component: 'DishesGroup',
                config: {
                  numberOfDishesPerPage: '2',
                  numberOfDishesPerRow: '2',
                  minNumberOfDishesPerRow: '1',
                  minNumberOfRowsPerPage: '1',
                  ...(opts.dishGroupConfig || {}),
                },
                datasets: {
                  dishes: opts.datasetName,
                  dishConfig: {
                    backgroundColor: 'white',
                    priceBackgroundColor: '#462E3F',
                    sizeFactor: (sizeFactor * 0.3 * (sides || waitingtime ? 0.8 : 1)) // On réduit légèrement la taille des plats si on a des accompagnements ou le temps d'attente
                      .toString(),
                    borderRadius: '0.75rem',
                    ...(opts.dishConfig || {}),
                  },
                  dishOrigins: opts.originsIcons,
                },
              },
              ...(sides
                ? {
                    sides: {
                      component: 'TText',
                      config: {
                        padding: '.75rem 0 0 0',
                        color: 'black',
                        fontSize: `${1.5 * sizeFactor}rem`,
                        fontWeight: '500',
                        fontFamily: 'Roboto, sans-serif',
                        text: sides,
                      },
                    },
                  }
                : {}),
              ...(waitingtime
                ? {
                    waitingtime: {
                      component: 'WaitingTime',
                      config: {
                        fontSize: '1.3rem',
                        borderRadius: '0.5rem',
                        margin: '0',
                        padding: '0.6rem 0.9rem',
                      },
                      datasets: {
                        data: opts.datasetName?.toString() || 'dishes',
                      },
                    },
                  }
                : {}),
            },
          },
        },
      },
    },
  };
};
